const eventYears = ["2025", "2024", "2023", "2022"];

export { eventYears };
